export default __webpack_public_path__ + "3b828463953a16e2cdb3edd0f2c21218.png";